import React from "react"

import { useRecoilState } from "recoil"
import { sizeState, themeState } from "../recoil-atom"

import { Flex } from "../styled-components-openmark"

const AboutJace = () => {
  const [size, setSize] = useRecoilState(sizeState)

  return (
    <Flex center>
      <div className="about-jace">
        <div id="header" align="center">
          <img alt="desk"
            src="https://media3.giphy.com/media/cNfIqjpCY1zqfaLmd8/giphy.gif"
            width="360"
          />
          {/* <div id="project-badges">
            <img
              src="https://img.shields.io/badge/Blog-03C75A?style=for-the-badge&logo=naver&logoColor=white"
              alt="Naver Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Japp-blue?style=for-the-badge&logo=vercel&logoColor=white"
              alt="Japp Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/JaDoc-darkgreen?style=for-the-badge&logo=vercel&logoColor=white"
              alt="JaDoc Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/GitHub-dddddd?style=for-the-badge&logo=github&logoColor=black"
              alt="Email Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Notion-161B22?style=for-the-badge&logo=notion&logoColor=white"
              alt="Notion Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Email-dddddd?style=for-the-badge&logo=mailgun&logoColor=black"
              alt="Email Badge"
              height="24px;"
            />
          </div> */}

          {/* <img
            src="https://komarev.com/ghpvc/?username=jacealan&style=flat-square&color=blue"
            alt=""
          /> */}

          <div id="python-badges">
            <img
              src="https://img.shields.io/badge/Python-1E425F?style=for-the-badge&logo=python&logoColor=white"
              alt="Python Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Pandas-130654?style=for-the-badge&logo=pandas&logoColor=white"
              alt="Pandas Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Matplotlib-65BAEA?style=for-the-badge&logo=soundcharts&logoColor=white"
              alt="Matplotlib Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Plotly-3E4A72?style=for-the-badge&logo=plotly&logoColor=white"
              alt="Plotly Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Django-0C4B33?style=for-the-badge&logo=django&logoColor=white"
              alt="Django Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Flask-333333?style=for-the-badge&logo=flask&logoColor=white"
              alt="Flask Badge"
              height="24px;"
            />
          </div>
          <div id="frontend-badges">
            <img
              src="https://img.shields.io/badge/Html-E54C21?style=for-the-badge&logo=html5&logoColor=white"
              alt="html Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Css-0066B6?style=for-the-badge&logo=css3&logoColor=white"
              alt="css Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Scss-BF4080?style=for-the-badge&logo=sass&logoColor=white"
              alt="scss Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Javascript-D6BA32?style=for-the-badge&logo=javascript&logoColor=black"
              alt="Javascript Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Nodejs-1F2F2B?style=for-the-badge&logo=node.js&logoColor=white"
              alt="Javascript Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/React-61DAFB?style=for-the-badge&logo=react&logoColor=black"
              alt="React Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Nextjs-222222?style=for-the-badge&logo=next.js&logoColor=white"
              alt="Next.js Badge"
              height="24px;"
            />
          </div>
          <div id="coding-badges">
            <img
              src="https://img.shields.io/badge/VSC-317AC6?style=for-the-badge&logo=visualstudiocode&logoColor=white"
              alt="html Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Colab-E8710A?style=for-the-badge&logo=googlecolab&logoColor=white"
              alt="css Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Replit-222222?style=for-the-badge&logo=replit&logoColor=white"
              alt="scss Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/Codesandbox-7B61FF?style=for-the-badge&logo=codesandbox&logoColor=white"
              alt="Javascript Badge"
              height="24px;"
            />
            <img
              src="https://img.shields.io/badge/vim-007900?style=for-the-badge&logo=vim&logoColor=white"
              alt="Javascript Badge"
              height="24px;"
            />
          </div>
          <hr />
          <div id="baekjoon">
            <img
              src="http://mazassumnida.wtf/api/v2/generate_badge?boj=jacealan"
              alt="Baekjoon"
            />
          </div>
        </div>
      </div>

      <style jsx>{`
        .about-jace {
          width: ${size.appWidth}px;
          padding: 20px 20px;
        }
      `}</style>
    </Flex>
  )
}

export default AboutJace
